module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("\n    Konta do wysyłania\n  ")]), _vm._v(" "), _c('p', {
    slot: "actions"
  }, [_c('ui-button', {
    attrs: {
      "type": "flat",
      "icon": "add_circle",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$router.push({
          name: 'admin.accounts.create'
        })
      }
    }
  }, [_vm._v("Dodaj konto")])], 1), _vm._v(" "), _c('accounts-list')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d79ac67","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/accounts/Dashboard.vue
// module id = 246
// module chunks = 0